import type { PlaybackClientApp } from '@amzn/bf-playback'

export const clientApp: PlaybackClientApp = { name: 'WebCP', version: '1.0.0' }
